import { Component, DestroyRef, inject } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { TranslocoService } from '@jsverse/transloco';
import { LangDirectionService } from '@rieaya-core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet>
    <p-toast [position]="isRtl ? 'bottom-left' : 'bottom-right'" />`,
  styles: [],
  imports: [RouterOutlet, ToastModule],
})
export class AppComponent {
  private translocoService = inject(TranslocoService);
  private langDirectionService = inject(LangDirectionService);
  private titleService = inject(Title);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  isRtl = true;

  constructor() {
    this.translocoService.langChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const currentLang = this.translocoService.getActiveLang();
        this.isRtl = currentLang === 'ar';
        this.langDirectionService.updateDirection();
        this.titleService.setTitle(
          currentLang === 'ar' ? environment.appTitleAr : environment.appTitleEn
        );
      });

    // Remove url queryParams after reload
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event) => event instanceof NavigationStart),
        take(1)
      )
      .subscribe((event: NavigationStart) => {
        const hasParams = event.url.includes('?');
        const isTokenUrl = event.url.includes('token=');
        const additionRequestUrl = event.url.includes(
          '/addition-requests/details'
        );
        const otherLoansUrl = event.url.includes('/other-loans/');

        if (hasParams && !isTokenUrl && !additionRequestUrl && !otherLoansUrl) {
          const cleanUrl = event.url.split('?')[0];

          this.router.navigateByUrl(cleanUrl, {
            replaceUrl: true,
          });
        }
      });
  }
}
